import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Label = styled.div`
  font-size: 12px;
  color: ${myPalette.mutedText.main};
  margin-bottom: 4px;
`

export const Field = styled.div`
  font-size: 16px;
  color: ${myPalette.midnightBlue.main};
  line-height: 24px;
`

export const FieldWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
`
export const EmailWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`
